import mapImg from "../../../../south-florida-map.png";

const COUNTIES = [
  "Miami-Dade",
  "Broward",
  "Palm Beach",
  "Martin",
  "Monroe",
  "St. Lucie",
  "Indian River",
  "Collier",
  "Lee",
];

export default function LocalSection() {
  return (
    <section className="py-24 md:py-32 bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
            <i className="ri-map-pin-2-line" />
            Rooted in South Florida
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
            Florida law is different. Your compliance partner should be too.
          </h2>
          <p className="mt-6 text-foreground-700 text-lg leading-relaxed">
            We're headquartered in Fort Lauderdale, and every consultant on our team lives inside the
            statute we work under. From the barrier islands of Palm Beach to the golf communities of Naples,
            we know how South Florida associations really operate and stay up to date on local website accessibility cases.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-3">
            {COUNTIES.map((c) => (
              <div
                key={c}
                className="bg-background-50 border border-background-200 rounded-md px-3 py-3 text-center text-sm font-medium text-foreground-800 flex items-center justify-center gap-1.5"
              >
                <i className="ri-map-pin-line text-primary-600 text-xs" />
                {c}
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-phone-line text-lg" />
              </div>
              <div>
                <div className="text-xs text-foreground-500 uppercase tracking-wide">Direct line</div>
                <a
                  href="tel:+19544444747"
                  className="font-heading text-xl font-semibold text-foreground-950 hover:text-primary-600 cursor-pointer"
                >
                  (954) 444-4747
                </a>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-mail-line text-lg" />
              </div>
              <div>
                <div className="text-xs text-foreground-500 uppercase tracking-wide">Board hotline</div>
                <a
                  href="mailto:boards@associationintegrity.com"
                  className="font-heading text-base font-semibold text-foreground-950 hover:text-accent-600 cursor-pointer"
                >
                  boards@associationintegrity.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative rounded-lg overflow-hidden border border-background-200 h-[520px]">
          <img
            src={mapImg}
            alt="South Florida map showing Fort Lauderdale, Broward, and Miami-Dade"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute bottom-4 left-4 right-4 bg-background-50/95 backdrop-blur-sm rounded-md border border-background-200 p-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-map-pin-2-line text-lg" />
              </div>
              <div>
                <div className="font-heading font-semibold text-foreground-950">
                  Fort Lauderdale & South Florida
                </div>
                <div className="text-sm text-foreground-700">
                  Serving HOAs & Condominiums Across All Counties
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}